import api from "@/services/api";
const methods = api.getPrefixedMethods("case-views");
/** Per-user read state of a case (LAM-5404). */
export const caseViewService = {
    markSeen(target) {
        return methods.post("", { ...target, seen: true });
    },
    markUnread(target) {
        return methods.post("", { ...target, seen: false });
    },
};
